import React, { useState } from "react";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Box, Tooltip } from "@mui/material";
import PaletteIcon from "@mui/icons-material/PaletteOutlined";
import CheckIcon from "@mui/icons-material/Check";
import { useThemeMode } from "../ThemeModeProvider";
import { PALETTES, PALETTE_LABELS } from "../theme";

/** Lets the user pick the app's colour theme at runtime (persisted). */
const ThemeColorPicker: React.FC<{ color?: string }> = ({ color }) => {
  const { palette, setPalette, keys } = useThemeMode();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  return (
    <>
      <Tooltip title="Theme colour">
        <IconButton onClick={(e) => setAnchor(e.currentTarget)} sx={{ color }}>
          <PaletteIcon />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
        {keys.map((k) => (
          <MenuItem key={k} selected={k === palette}
            onClick={() => { setPalette(k); setAnchor(null); }}>
            <ListItemIcon>
              <Box sx={{ width: 18, height: 18, borderRadius: "50%", bgcolor: PALETTES[k].green, border: "1px solid rgba(0,0,0,.15)" }} />
            </ListItemIcon>
            <ListItemText>{PALETTE_LABELS[k] || k}</ListItemText>
            {k === palette && <CheckIcon fontSize="small" color="primary" />}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ThemeColorPicker;
